export const moduleName = "favorites";
